/* unplugin-vue-components disabled */import { render } from "./red_note.vue?vue&type=template&id=e60f9fc6&scoped=true"
import script from "./red_note.vue?vue&type=script&lang=js"
export * from "./red_note.vue?vue&type=script&lang=js"

import "./red_note.vue?vue&type=style&index=0&id=e60f9fc6&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60f9fc6"]])

export default __exports__